import React from 'react';
import Section from '@components/Section';
import {
  ReconnectMoIcon,
  ReconnectQrIcon,
  ReconnectWkIcon,
  ReconnectYrIcon,
} from '@components/Icons';
import { AutoReconnectIcon, NoReconnectIcon } from '@components/Icons/Reconnect';
import { GroupReconnectCadence } from '@models/Group';
import styles from './GroupReconnect.module.scss';
import cn from 'classnames';
import Tooltip, { Overlay } from '@components/Tooltip';

export const cadenceOptions: Record<GroupReconnectCadence, { label: string; icon: React.FC<any> }> =
  {
    weekly: {
      label: 'Weekly',
      icon: ReconnectWkIcon,
    },
    monthly: {
      label: 'Monthly',
      icon: ReconnectMoIcon,
    },
    quarterly: {
      label: 'Quarterly',
      icon: ReconnectQrIcon,
    },
    yearly: {
      label: 'Yearly',
      icon: ReconnectYrIcon,
    },
    auto: {
      label: 'Auto',
      icon: AutoReconnectIcon,
    },
    disabled: {
      label: 'None',
      icon: NoReconnectIcon,
    },
  };

interface GroupReconnectProps {
  cadence: GroupReconnectCadence;
  onSelect: (cadence: GroupReconnectCadence) => void;
}

export default function GroupReconnect({ cadence, onSelect }: GroupReconnectProps) {
  return (
    <Section>
      <Section.Title underline>Reconnect</Section.Title>
      <Section.Description>Adjust the Reconnect cadence of this group.</Section.Description>
      <ul className={styles.list}>
        {Object.entries(cadenceOptions).map(([key, { label, icon: IconComponent }]) => (
          <li key={key} className={cn(styles.cadence, cadence === key && styles.selected)}>
            <Tooltip placement={'bottom'} overlay={<Overlay>{label}</Overlay>}>
              <button
                type="button"
                className={styles.button}
                onClick={() => onSelect(key as GroupReconnectCadence)}
              >
                <IconComponent className={styles.icon} />
              </button>
            </Tooltip>
          </li>
        ))}
      </ul>
    </Section>
  );
}
